export { default } from "./getIdentifierType";
